import clsx from "clsx";
import { MASCOTE_SPACE_TCHAU } from "../appAssistenteIA.constants";

type AppAssistenteIAInformativoProps = {
	readonly titulo: string;
	readonly descricao: string;
	readonly itens?: readonly string[];
	readonly className?: string;
};

export default function AppAssistenteIAInformativo({
	titulo,
	descricao,
	itens,
	className,
}: AppAssistenteIAInformativoProps) {
	return (
		<section
			className={clsx(
				"animate-app-assistente-panel-in mx-auto flex w-full max-w-2xl flex-col items-center px-3 py-8 text-center",
				className,
			)}
		>
			<img
				src={MASCOTE_SPACE_TCHAU}
				alt="Mascote SPACE"
				className="animate-app-assistente-mascot-in h-64 w-64 object-cover object-top"
			/>

			<h3 className="animate-app-assistente-title-in mt-4 text-lg font-semibold text-foreground">{titulo}</h3>
			<p className="animate-app-assistente-description-in mt-2 max-w-xl text-sm leading-6 text-muted-foreground">
				{descricao}
			</p>

			{itens?.length ? (
				<ul className="mt-5 grid w-full gap-2 text-left sm:grid-cols-2">
					{itens.map((item, index) => (
						<li
							key={item}
							className="animate-app-assistente-suggestion-in flex gap-2 rounded-md border bg-background px-3 py-2 text-sm opacity-0"
							style={{ animationDelay: `${220 + index * 80}ms` }}
						>
							<span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-secondary" />
							<span className="leading-5 text-foreground">{item}</span>
						</li>
					))}
				</ul>
			) : null}
		</section>
	);
}
